import { useCallback, useState } from "react";

import {
  issueEndorsement,
  selectEndorsementId,
  selectEndorsementLoadingFromBackend,
  useEndorsementSelector,
} from "@redux/slices/endorsement";
import { useAppDispatch } from "@redux/hooks";
import { usePaymentMethods } from "@routing/routes/Policies/PolicyDetails/Endorsements/CheckoutStep/PaymentMethods/usePaymentMethods";

interface UseEndorsementIssueParams {
  onSuccess: () => void;
}

export function useEndorsementIssue({ onSuccess }: UseEndorsementIssueParams) {
  const dispatch = useAppDispatch();
  const [isIssuing, setIsIssuing] = useState(false);
  const { isDefaultCardExpired } = usePaymentMethods();
  // Covers both the id carried in the URL (update/issue) and the one created
  // mid-flow (create), which never reaches the search params.
  const endorsementLocator = useEndorsementSelector(selectEndorsementId);
  const isLoadingFromBackend = useEndorsementSelector(
    selectEndorsementLoadingFromBackend
  );

  const disableSubmit =
    isLoadingFromBackend || isDefaultCardExpired || !endorsementLocator;

  const handleSubmitIssue = useCallback(async () => {
    if (disableSubmit) {
      return;
    }

    setIsIssuing(true);
    const result = await dispatch(issueEndorsement());
    setIsIssuing(false);

    if (issueEndorsement.fulfilled.match(result)) {
      onSuccess();
    }
  }, [dispatch, onSuccess, disableSubmit]);

  return {
    isIssuing,
    disableSubmit,
    handleSubmitIssue,
  };
}
